import React, { useState, useEffect, useCallback } from 'react'
import './Hero.css'
import Navbar from '../Navbar/Navbar'
import { useTranslation } from 'react-i18next';

const heroSlides = [
  'hero-bg.png',
  'hero-slide-1.png',
  'hero-slide-2.png',
  'hero-slide-3.png',
]

const Hero = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0)

  const next = useCallback(() => {
    setCurrent(c => (c + 1) % heroSlides.length)
  }, [])

  // Auto-advance every 5 seconds
  useEffect(() => {
    const timer = setInterval(next, 5000)
    return () => clearInterval(timer)
  }, [next])

  return (
    <>
      <header id='home'>
        {/* Background slides */}
        {heroSlides.map((img, i) => (
          <div
            key={i}
            className={`hero-bg-slide ${i === current ? 'active' : ''}`}
            style={{ backgroundImage: `url('${img}')` }}
          />
        ))}

        {/* Navbar */}
        <div className="container-fluid px-md-5 px-3 position-relative" style={{ zIndex: 2 }}>
          <Navbar />
        </div>

        {/* Fixed content */}
        <div className={`container hero-main position-relative${current === 1 ? ' hero-main--hidden-text' : ''}`} style={{ zIndex: 2 }}>
          <h1 className='main-h1'>{t('hero.title')}</h1>
          <p className='sub-p'>
            {t('hero.desc')}
          </p>
          <div className="hero-btns d-flex gap-3">
            <a href="#join" className="btn btn-outline-light w-200px py-2 d-flex align-items-center justify-content-center text-decoration-none">{t('hero.partner_btn')}</a>
            <a href="#contact" className="contact-btn rounded-1 py-2 d-flex align-items-center justify-content-center text-decoration-none">{t('nav.contact_us')}</a>
          </div>
        </div>

        {/* Slide indicators */}
        <div className="hero-dots">
          {heroSlides.map((_, i) => (
            <button
              key={i}
              className={`hero-dot ${i === current ? 'active' : ''}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </header>
    </>
  )
}

export default Hero